import { render, staticRenderFns } from "./EditReasonPopup.vue?vue&type=template&id=0d2b9fde&scoped=true&"
import script from "./EditReasonPopup.vue?vue&type=script&lang=js&"
export * from "./EditReasonPopup.vue?vue&type=script&lang=js&"
import style0 from "./EditReasonPopup.vue?vue&type=style&index=0&id=0d2b9fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2b9fde",
  null
  
)

export default component.exports